/* * 查询模块 区域查询 * @module components/queryComponent/propertyQuery * @desc 用于区域查询 * @author qqjuanqq *
@date 2022-9-9 */
<template>
  <div class="queryAllCal">
    <Row class="queryMethods" type="flex">
      <Col span="24" style="display:flex;">
        <div class="iconstyle" @click="drawArea('Box')">
          <img src="../../../../static/image/analysis/面/fill_uncheck.png" />
          <div class="text">面</div>
        </div>
        <div class="iconstyle" @click="drawArea('Polygon')">
          <img src="../../../../static/image/analysis/异形/poly_uncheck.png" />
          <div class="text">异形</div>
        </div>
        <Upload
          style="display: inline-block; float: left"
          :show-upload-list="false"
          accept=".txt"
          :before-upload="txtBeforupload"
          action
        >
          <div class="iconstyle" style="margin-left: -3px">
            <img src="../../../../static/image/analysis/txt/txt_uncheck.png" />
            <div class="text">上传txt</div>
          </div>
        </Upload>

        <Upload
          style="display: inline-block; float: left"
          :show-upload-list="false"
          accept=".shp"
          :before-upload="shpBeforupload"
          :on-success="handleSuccess"
          :headers="accessToken"
          action="/zituSpace/polygonGeojsonData/uploadShpToGeojsonStr"
        >
          <div class="iconstyle">
            <img src="../../../../static/image/analysis/shp/shp_uncheck.png" />
            <div class="text">上传shp</div>
          </div>
        </Upload>
        <div class="iconstyle" @click="drawArea('delete')">
          <img src="../../../../static/image/analysis/删除/del_uncheck.png" />
          <div class="text">删除</div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import queryPanel from './queryPanel.js';
export default queryPanel;
</script>
<style lang="less" scoped>
.queryAllCal{
  width: 360px;
  height: 34px;
  background: #fff;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}
.iconstyle {
  margin: 6px 4px 6px 0;
  text-align: center;
  list-style: none;
  cursor: pointer;
  height: 20px;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  flex: 1;
  border-right: 1px solid #eeeeee;
  font-size: 12px;
}
.iconstyle img {
  display: inline-block;
  text-align: center;
  margin: 0 2px 0 3px;
  color: #333;
}
.iconstyle .text {
  text-align: center;
  font-size: 14px;
}
/deep/.ivu-form-item {
  margin-bottom: 10px;
}
/deep/.ivu-form-item-label {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftmenu/query/queryPanel.vue